module.exports = __webpack_public_path__ + "img/completed.55aedc3f.svg";